/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import { MenuComponent } from '../../../assets/ts/components'
import { setLanguage, useLang } from '../../../i18n/Metronici18n'
import { processGet } from '../../../../services/api'
import { useIntl } from 'react-intl'
import { AUTH_LOCAL_STORAGE_KEY } from '../../../../app/modules/auth'


export function HeaderWrapper() {

  const [runUpdate, setRunUpdate] = React.useState({lastUpdate: '', nextUpdate: ''});
  const intl = useIntl()
  const selectedTenant = localStorage.getItem('selectedTenant');
  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  console.log("lsValue",lsValue);
  useEffect(() => {

    const fetchUpdate = async () => {
      let result:any = await processGet("system-settings/last-update")
      let last_update = intl.formatDate(new Date(result.lastUpdate))+ ' ' + intl.formatTime(new Date(result.lastUpdate));

      let date = new Date();
      let hour = parseInt(date.getHours()+"");  
    
      if(hour % 2 === 0){ 
        date.setHours(hour+2);
      }else{
        date.setHours(hour+1);
      }
      date.setMinutes(0);
      date.setSeconds(0);
      let next_run = intl.formatDate(date) + ' ' + intl.formatTime(date);
      setRunUpdate({lastUpdate: last_update, nextUpdate: next_run});
      
    }
    fetchUpdate()
    const interval = setInterval(() => {
      fetchUpdate()
    }, 10000); // Update count every 2 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config

  const locale = useLang();
  console.log(locale);
  const flags = {
    it: 'italy.svg',
    en: 'united-states.svg',
    es: 'spain.svg',
    pt: 'portugal.svg'
  }
  const langs = {
    it: 'Italiano',
    en: 'English',
    es: 'Español',
    pt: 'Português',
  }
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.createInstances('[data-kt-menu-lang="true"]')
    }, 100)
  }
  , [])

  return (
    <div
      id='kt_header'
      className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
      data-kt-sticky='true'
      data-kt-sticky-name='header'
      data-kt-sticky-offset="{default: '200px', lg: '300px'}"
      {...attributes.headerMenu}
    >
      <div className={clsx(classes.headerContainer.join(' '), 'd-flex align-items-center')}>
        {/* begin::Aside mobile toggle */}
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div
              className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px'
              id='kt_aside_mobile_toggle'
            >
              <KTIcon iconName='abstract-14' className='fs-2x mt-1' />
            </div>
          </div>
        )}
        {/* end::Aside mobile toggle */}

        <div
          className='d-flex topbar align-items-center d-lg-none ms-n2 me-3'
          title='Show aside menu'
        >
          <div
            className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px'
            id='kt_header_menu_mobile_toggle'
          >
            <KTIcon iconName='abstract-14' className='fs-2x' />
          </div>
        </div>

        <div className='header-logo me-5 me-md-10 flex-grow-1 flex-lg-grow-0'>
          <Link to='/'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/INSIGHT-negativo.png')}
              className='logo-default h-20px'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/INSIGHT.png')}
              className='logo-sticky h-20px'
            />
          </Link>
        </div>

        {/* begin::Wrapper */}
        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          {/* begin::Navbar */}
          {header.left === 'menu' && (
            <div className='d-flex align-items-stretch' id='kt_header_nav'>
              <Header />
            </div>
          )}

          {header.left === 'page-title' && (
            <div className='d-flex align-items-center' id='kt_header_nav'>
              <DefaultTitle />
            </div>
          )}

          <div className='d-flex align-items-stretch flex-shrink-0'>
            {/* begin::Drop down per la scelta della linga */}
          <div className='text-white-shrink me-10'>

            {runUpdate.lastUpdate && <> {intl.formatMessage({id:"GENERIC.LAST_UPDATE"})}: {runUpdate.lastUpdate}<br /> </>}
            {runUpdate.lastUpdate && <> {intl.formatMessage({id:"GENERIC.NEXT_RUN"})}: {runUpdate.nextUpdate}<br /> </>}
            {intl.formatMessage({id:"GENERIC.SELECTED_TENANT"})}: {selectedTenant}
          </div>
            <div className='m-0'>
              <a
                href='#'
                className='btn btn-sm btn-light btn-color-gray-700 btn-flex btn-center  fw-bold'
                data-kt-menu-trigger='hover'
                data-kt-menu-placement='bottom-end'
              >
                <img src={toAbsoluteUrl('/media/flags/'+flags[locale])} alt='' className='w-20px h-20px me-3' />{' '}{langs[locale]}
              </a>
              
            
              <div
        data-kt-menu-lang='true'
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-250px pt-2 pb-2'
      >
          {locale != 'it' && <div className='menu-item px-3'>
            <a href='#' onClick={()=>{setLanguage('it')}} className='menu-link px-3' data-kt-menu-trigger='hover' data-kt-menu-target='#kt_menu_lang_dropdown'>
              <span className='menu-title'><img src={toAbsoluteUrl('/media/flags/'+flags['it'])} alt='' className='h-20px me-3' />{' '} {langs['it']}</span>
            </a>
          </div>}

          {locale != 'en' && <div className='menu-item px-3'>
            <a href='#' onClick={()=>{setLanguage('en')}} className='menu-link px-3' data-kt-menu-trigger='hover' data-kt-menu-target='#kt_menu_lang_dropdown'>
              <span className='menu-title'><img src={toAbsoluteUrl('/media/flags/'+flags['en'])} alt='' className='h-20px me-3' />{' '} {langs['en']}</span>
            </a>
          </div>}

          {locale != 'es' && <div className='menu-item px-3'>
            <a href='#' onClick={()=>{setLanguage('es')}} className='menu-link px-3' data-kt-menu-trigger='hover' data-kt-menu-target='#kt_menu_lang_dropdown'>
              <span className='menu-title'><img src={toAbsoluteUrl('/media/flags/'+flags['es'])} alt='' className='h-20px me-3' />{' '} {langs['es']}</span>
            </a>
          </div>}

          {locale != 'pt' && <div className='menu-item px-3'>
            <a href='#' onClick={()=>{setLanguage('pt')}} className='menu-link px-3' data-kt-menu-trigger='hover' data-kt-menu-target='#kt_menu_lang_dropdown'>
              <span className='menu-title'><img src={toAbsoluteUrl('/media/flags/'+flags['pt'])} alt='' className='h-20px me-3' />{' '} {langs['pt']}</span>
            </a>
          </div>}
      </div>
            </div>
            {/* end::Drop down per la scelta della linga */}

            {/* begin::Topbar */}

            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
